import { useEffect } from 'react'

/*
 * Workaround for React-calendar:
 * When a month/year is selected, React-calendar removes the event target from the DOM.
 * Therefore, this workaround is necessary to prevent the dropdown from closing unintentionally.
 */
export function useTimePickerClickOutside(
  ref: React.RefObject<HTMLElement>,
  isOpen: boolean,
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>,
): void {
  useEffect(() => {
    const handleClick = (e: MouseEvent): void => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        const element = e.target as HTMLElement
        const className =
          typeof element.className === 'string' ? element.className : ''
        if (
          element.tagName !== 'ABBR' &&
          !className.split(' ').includes('react-calendar__tile')
        ) {
          if (isOpen) setIsOpen(false)
        }
      }
    }

    document.addEventListener('click', handleClick)
    return () => {
      document.removeEventListener('click', handleClick)
    }
  }, [ref, isOpen, setIsOpen])
}
